import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex gap-1" }
const _hoisted_5 = ["onClick", "disabled"]
const _hoisted_6 = { class: "text-xl" }
const _hoisted_7 = { class: "absolute -top-8 left-1/2 -translate-x-1/2 px-2 py-1 text-xs bg-primary-800 text-white rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none" }

import { ref, PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  showLabel: {
    type: Boolean,
    default: true,
  },
  position: {
    type: String as PropType<"top" | "bottom">,
    default: "bottom",
  },
  currentReactions: {
    type: Array as PropType<ReactionSummary[]>,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["select"],
  setup(__props, { emit }: { emit: ({
  (e: "select", reactionType: ReactionType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const isOpen = ref(false);

const reactions = [
  { type: "like" as ReactionType, emoji: "👍", label: "Like" },
  { type: "love" as ReactionType, emoji: "❤️", label: "Love" },
  { type: "laugh" as ReactionType, emoji: "😄", label: "Haha" },
  { type: "thinking" as ReactionType, emoji: "🤔", label: "Thinking" },
  { type: "clap" as ReactionType, emoji: "👏", label: "Applause" },
  { type: "100" as ReactionType, emoji: "💯", label: "100%" },
];

const togglePicker = () => {
  isOpen.value = !isOpen.value;
};

const isSelected = (type: ReactionType): boolean => {
  return props.currentReactions.some(
    (r) => r.reaction_type === type && r.user_reacted
  );
};

const selectReaction = (type: ReactionType) => {
  emit("select", type);
  isOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: togglePicker,
      class: _normalizeClass(["flex items-center gap-1 px-2 py-1 text-sm text-primary-500 hover:text-primary-700 hover:bg-primary-50 rounded-lg transition-colors", { 'bg-primary-50': isOpen.value }])
    }, [
      _hoisted_2,
      (__props.showLabel)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "React"))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["absolute right-0 z-50 mt-1 bg-white rounded-xl shadow-lg border border-primary-100 p-2", __props.position === 'top' ? 'bottom-full mb-1' : 'top-full'])
            }, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reactions, (reaction) => {
                  return _createElementVNode("button", {
                    key: reaction.type,
                    onClick: ($event: any) => (selectReaction(reaction.type)),
                    class: _normalizeClass(["p-2 rounded-lg hover:bg-primary-50 transition-all hover:scale-110 relative group", {
              'bg-accent-50 ring-2 ring-accent-200': isSelected(reaction.type),
            }]),
                    disabled: __props.loading
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(reaction.emoji), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(reaction.label), 1)
                  ], 10, _hoisted_5)
                }), 64))
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-40",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})